import { __exports as allcaps } from './_virtual-allcaps.js';

var hasRequiredAllcaps;

function requireAllcaps () {
	if (hasRequiredAllcaps) return allcaps;
	hasRequiredAllcaps = 1;

	Object.defineProperty(allcaps, "__esModule", {
	  value: true
	});
	allcaps.filter = filter;
	allcaps.name = void 0;
	allcaps.name = 'allcaps';
	async function filter(text) {
	  return "<span class=\"swan-text-all-caps\">".concat(text, "</span>");
	}
	
	return allcaps;
}

export { requireAllcaps as __require };
//# sourceMappingURL=vp-js-token-engine-build-filters-allcaps.js.map
